import { gql } from '@/lib/graphql/gql'

export const APPLICATION_CLUSTERS_QUERY = gql`
  query ApplicationClusters($idCompany: String!) {
    company(id: $idCompany) {
      id
      clusters {
        id
        location
        displayName
        isBoosted
        provider
      }
      recentClusters {
        id
        location
        displayName
        isBoosted
        provider
      }
    }
  }
`
